const setGap = data => ({
  type: 'SET_GAP_DATA',
  payload: data,
});

export { setGap };
